import {get} from "lodash";
import {makeAutoObservable} from "mobx";
import {inject, injectable} from "inversify";
import {ViewController} from "data/types/structure";
import {Bindings} from "data/constants/bindings";
import type {ILocalizationStore} from "data/stores/localization/localization.store";
import type {ILeaderboardsStore, IPlayerRanking} from "data/stores/leaderboards/leaderboards.store";
import type {IPlayerModalStore} from "data/stores/player_modal/player_modal.store";
import type {IPlayerOdds} from "data/providers/api/tournament.provider";
import type {ICountryStore} from "data/stores/country/country.store";
import {getOddsTransformValueWith} from "data/utils/helper";

export interface IPlayersLeaderboardController extends ViewController {
	readonly i18n: ILocalizationStore;

	get rankingList(): IPlayerRanking[];

	openPlayerModal: (playerId: number) => void;
	getOddsValue: (value: IPlayerOdds | null) => string;
}

@injectable()
export class PlayersLeaderboardController implements IPlayersLeaderboardController {
	get rankingList() {
		return this._leaderboardsStore.playersRanking;
	}

	private get isShowOdds() {
		return this._countryStore.isShowOdds;
	}

	constructor(
		@inject(Bindings.LocalizationStore) public readonly i18n: ILocalizationStore,
		@inject(Bindings.LeaderboardsStore) public _leaderboardsStore: ILeaderboardsStore,
		@inject(Bindings.PlayerModalStore) public _playerModalStore: IPlayerModalStore,
		@inject(Bindings.CountryStore) private _countryStore: ICountryStore
	) {
		makeAutoObservable(this);
	}

	openPlayerModal = (playerId: number) => {
		this._playerModalStore.setPlayerId(playerId);
		this._playerModalStore.setPageArea("fantasy_leaderboard");
		this._playerModalStore.openPlayerModal();
	};

	getOddsValue = (value: IPlayerOdds | null) => {
		if (!this.isShowOdds || !value) {
			return "-";
		}

		return getOddsTransformValueWith(get(value, this._countryStore.country));
	};
}
